<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4978_8596)">
      <path
        d="M11 0.6875C16.6954 0.6875 21.3125 5.30456 21.3125 11C21.3125 16.6954 16.6954 21.3125 11 21.3125C5.30456 21.3125 0.6875 16.6954 0.6875 11C0.6875 5.30456 5.30456 0.6875 11 0.6875ZM11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75ZM10.3125 5.84375C10.882 5.84375 11.3438 6.30546 11.3438 6.875V10.6562H13.75C14.3195 10.6562 14.7812 11.118 14.7812 11.6875C14.7812 12.257 14.3195 12.7188 13.75 12.7188H10.3125C9.74296 12.7188 9.28125 12.257 9.28125 11.6875V6.875C9.28125 6.30546 9.74296 5.84375 10.3125 5.84375Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4978_8596">
        <rect
          width="22"
          height="22"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
